import React, { useState, useEffect } from 'react';
import './Cards.css';

export const HighlightCard: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`waiting-card highlight-card highlight-card--placeholder ${isVisible ? 'visible' : ''}`}>
      <div className="highlight-card__header">
        <span className="highlight-card__icon">✨</span>
        <span className="highlight-card__label">Öne Çıkanlar</span>
      </div>

      <div className="highlight-card__content">
        <p className="highlight-card__title">Yeni özellikler geliyor!</p>
        <p className="highlight-card__description">
          Stil önerileri ve trend ürünler yakında burada!
        </p>
      </div>
    </div>
  );
};

export default HighlightCard;
